<template>
  <ul class="comments-wrapper">
    <edi-comment-list-item
      v-for="(comment, index) in comments"
      :key="index"
      :comment="comment"
      :content-id="contentId"
      :comment-type="commentType"
    />
  </ul>
</template>

<script>
import EdiCommentListItem from '../list-item/EdiCommentListItem';

export default {
  name: 'edi-comment-list',
  components: {
    EdiCommentListItem,
  },
  props: {
    contentId: Number,
    comments: Array,
    commentType: Number,
  },
};
</script>
